import { Api } from '@/api/api.client';
import type { Components } from '@/api/generated/api';

export async function updateSchoolClassAppearance(params: {
  schoolClassId: number;
  dto: Components.Schemas.UpdateEntityAppearanceDto;
}): Promise<Components.Schemas.SchoolClassDto> {
  const result = await Api.Routes.EntityAppearance.updateClassAppearance({ id: params.schoolClassId }, params.dto);
  return result.data;
}

export async function uploadSchoolClassImage(params: {
  schoolClassId: number;
  file: File;
}): Promise<Components.Schemas.SchoolClassDto> {
  const result = await Api.Routes.EntityAppearance.uploadClassImage(
    { id: params.schoolClassId },
    { file: params.file },
  );
  return result.data;
}
